import React from "react";
import styled from "styled-components";

import {
  //   getFontFamily,
  getSize,
  //   isTouchDevice,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { EnergyPackage } from "../components/EnergyPackage";

import EnergyPkg1 from "images/energy_pkg_1.png";
import EnergyPkg2 from "images/energy_pkg_2.png";
import EnergyPkg3 from "images/energy_pkg_3.png";
import EnergyPkg4 from "images/energy_pkg_4.png";

const EnergyPackageList = styled.ul`
  list-style: none;
  margin: 0px 0px 15px 0px;
  padding: 0px 40px;
  @media screen and (min-width: ${getSize("default")}) {
    display: grid;
    float: left;
    grid-template-rows: 482px;
    grid-template-columns: 300px 300px 300px 300px;
    grid-column-gap: 16px;
  }
  @media screen and (min-width: ${getSize("mobile480")}) {
    padding: 0px 90px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    display: grid;
    float: unset;
    grid-template-rows: 492px 492px;
    grid-template-columns: 300px 300px;
    grid-column-gap: 16px;
    grid-row-gap: 18px;
    justify-content: center;
    padding: 0px;
    width: 100%;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    grid-column-gap: 18px;
    grid-row-gap: 21px;
    grid-template-columns: 324px 324px;
    grid-template-rows: 532px 532px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    grid-template-columns: 324px 324px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    grid-template-columns: 420px 420px;
    grid-template-rows: 688px 688px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    grid-template-columns: 420px 420px 420px 420px;
    grid-template-rows: 688px;
    grid-column-gap: 24px;
  }
`;

export const energyPackagesListElement = (
  <EnergyPackageList>
    <EnergyPackage
      image={{ src: EnergyPkg1, alt: "Mobile app monitoring energy" }}
    >
      {"Energy monitoring"}
    </EnergyPackage>
    <EnergyPackage
      image={{
        src: EnergyPkg2,
        alt: "Mobile app controlling lights and loads",
      }}
    >
      {"Energy monitoring"}
      {"Control of lighting loads"}
      {"Flexible Load Management"}
    </EnergyPackage>
    <EnergyPackage image={{ src: EnergyPkg3, alt: "Illustrated home" }}>
      {"Renewable storage for critical and essential loads"}
      {"Energy monitoring"}
      {"Control and energy monitoring of lighting"}
      {"Flexible Load Management"}
    </EnergyPackage>
    <EnergyPackage image={{ src: EnergyPkg4, alt: "Illustrated home" }}>
      {"Renewable storage from critical loads to whole home"}
      {"Energy monitoring"}
      {"Control and energy monitoring of lighting"}
      {"Flexible Load Management"}
    </EnergyPackage>
  </EnergyPackageList>
);
